import { Box, useMediaQuery, queryHelpers } from "@leagueplatform/genesis-core";

export const CenteredLayout = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useMediaQuery(queryHelpers.down("tablet"));

  return (
    <Box
      css={{
        background: isMobile
          ? "$surfaceBackgroundPrimary"
          : "$surfaceBackgroundSecondary",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "0" : "$three",
      }}
    >
      <Box
        css={{
          width: "100%",
          maxWidth: isMobile ? "100%" : "708px",
          background: "$surfaceBackgroundPrimary",
          boxShadow: isMobile ? "none" : "$card",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
